export function parseCommaSeparatedKeys(value) {
  if (Array.isArray(value)) {
    return [...new Set(value.map((key) => String(key).trim()).filter(Boolean))]
  }
  if (!value || typeof value !== 'string') return []
  return [...new Set(value.split(',').map((key) => key.trim()).filter(Boolean))]
}

export function catalogKeySet(entries = []) {
  return new Set(entries.map((entry) => entry.key).filter(Boolean))
}

export function findUnknownKeys(keys, allowedSet) {
  if (!keys.length) return []
  return keys.filter((key) => !allowedSet.has(key))
}

export function unknownKeysMessage(keys, label) {
  if (!keys.length) return null
  return `Unknown ${label}: ${keys.join(', ')}`
}

export function extrasNotInIncoming(current = [], incoming = []) {
  const incomingSet = new Set(incoming)
  return current.filter((key) => !incomingSet.has(key))
}

export function downloadCsv(filename, lines) {
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}
